export default __webpack_public_path__ + "static/media/bread.3f06034b.jpg";